/* istanbul ignore file */
import React, { useMemo } from 'react'
import moment from 'moment-timezone'
import type { Maybe, GenericDate } from '@adc/sdk/types'
import { CountdownMatchBid } from '../../../modules/auctionCountdown'
import MatchBidHeader from './matchBidHeader'

const MatchBidTimer = ({
  matchBiddingPeriodEndDate,
  text,
  currentServerTime,
}: {
  matchBiddingPeriodEndDate: Maybe<GenericDate> | undefined
  text?: string
  currentServerTime: moment.Moment
}) => {
  const matchBiddingEndTime = useMemo(
    () => moment(matchBiddingPeriodEndDate),
    [matchBiddingPeriodEndDate]
  )

  return (
    <div>
      <MatchBidHeader />
      {matchBiddingPeriodEndDate && (
        <div className='u-mt-2'>
          <CountdownMatchBid
            matchBiddingEndTime={matchBiddingEndTime}
            text={text}
            currentServerTime={currentServerTime}
          />
        </div>
      )}
    </div>
  )
}

export default MatchBidTimer
